import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_MAIL_MESSAGES } from '@/api/endpoints';
import type { FollowUpStatus } from '@/types/components';
import { ErrorMessage, logRequestError } from '@/utils/errors';

export interface FollowUpVariables {
  messageId: string;
  followUpStatus: FollowUpStatus;
  previousStatus: FollowUpStatus;
}

interface Params {
  onError: (variables: FollowUpVariables) => void;
}

export const useFollowUpStatus = ({ onError }: Params) =>
  useMutation({
    mutationFn: ({ messageId, followUpStatus }: FollowUpVariables) =>
      apiClient.patch(API_MAIL_MESSAGES, {
        followUpStatus,
        messageIds: [Number(messageId)],
      }),
    onError: (error, variables) => {
      logRequestError(ErrorMessage.ChangeFollowUpStatus, error);
      onError(variables);
    },
  });
